module.exports = __webpack_public_path__ + "media/img/illustrations/lost-c88ea20fd03db5e75e4a16a6604bab0b.svg";